import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Employees.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { SetAuditTrail } from './../Reports/AuditTrailReportEmployeeSetup';
import axios from '../../api/apiClient';
import { fetchAvailableSlot, checkLicenseIfTaken, insertUserSubscription } from '../../api/subscriptionApi';
import { token, domain } from '../Security';
import {
  HR7_IS_CLOUD,
  getUnliAccount
} from '../Security';
import loadingSpinner from './../../assets/loading.gif';

// icons
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PersonalTab } from './ViewEmployeeFld/tabs/PersonalTab';
import { AddressTab } from './ViewEmployeeFld/tabs/AddressTab';
import { InformationTab } from './ViewEmployeeFld/tabs/InformationTab';
import { AccountsTab } from './ViewEmployeeFld/tabs/AccountsTabFld/AccountsTab';
import { EducationsTab } from './ViewEmployeeFld/tabs/EducationsTab';
import { TrainingsAndSeminarsTab } from './ViewEmployeeFld/tabs/TrainingsAndSeminarsTab';
import { DependentsTab } from './ViewEmployeeFld/tabs/DependentsTab';
import { EmergencyTab } from './ViewEmployeeFld/tabs/EmergencyTab';
import { FamilyTab } from './ViewEmployeeFld/tabs/FamilyTab';

function AddEmployee({ user, isHideSideMenu }) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedEducationTab, setSelectedEducationTab] = useState(0);
  const [isFirstPage, setIsFirstPage] = useState(true);
  const [isLastPage, setIsLastPage] = useState(false);
  const [loading, setLoading] = useState(false);

  //Personal
  const [employeeId, setEmployeeId] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [extensionName, setExtensionName] = useState("");
  const [nickName, setNickName] = useState("");
  const [age, setAge] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [civilStatus, setCivilStatus] = useState("");
  const [bloodType, setBloodType] = useState("");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [citizenship, setCitizenship] = useState("");
  const [religion, setReligion] = useState("");
  const [gender, setGender] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [deviceNumber, setDeviceNumber] = useState("");
  const [companyId, setCompanyTypeId] = useState("");
  const [signature, setSignature] = useState([]);
  const [license, setLicense] = useState("");
  //Address
  const [blkLot, setBlkLot] = useState("");
  const [street, setStreet] = useState("");
  const [barangay, setBarangay] = useState("");
  const [city, setCity] = useState("");
  const [municipality, setMunicipality] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [yearsOfStay, setYearsOfStay] = useState("");
  //Information
  const [effectiveFrom, setEffectiveFrom] = useState("");
  const [contractFrom, setContractFrom] = useState("");
  const [contractTo, setContractTo] = useState("");
  const [locationId, setLocationId] = useState("");
  const [dateEmployed, setDateEmployed] = useState("");
  const [dateRegular, setDateRegular] = useState("");
  const [dateProbationary, setDateProbationary] = useState("");
  const [dateProjectBase, setDateProjectBase] = useState("");
  const [dateContractual, setDateContractual] = useState("");
  const [employmentId, setEmploymentId] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [classificationId, setClassificationId] = useState("");
  const [payTypeId, setPayTypeId] = useState("");
  const [shiftScheduleId, setShiftScheduleId] = useState("");
  const [positionId, setPositionId] = useState("");
  const [salaryType, setSalaryType] = useState("");
  const [maintenanceSalaryCombinationV2Id, setmaintenanceSalaryCombinationV2Id] = useState("");
  const [sickLeave, setSickLeave] = useState("");
  const [vacationLeave, setVacationLeave] = useState("");
  const [serviceIncentiveLeave, setServiceIncentiveLeave] = useState("");
  const [soloParentLeave, setSoloParentLeave] = useState("");
  const [sickRemaining, setSickRemaining] = useState("");
  const [vacationRemaining, setVacationRemaining] = useState("");
  const [serviceIncentiveRemaining, setServiceIncentiveRemaining] = useState("");
  const [soloParentRemaining, setSoloParentRemaining] = useState("");
  const [employeeStatus, setEmployeeStatus] = useState("");
  const [jobTitleId, setJobTitleId] = useState("");
  const [employeeGroup1Id, setEmployeeGroup1Id] = useState("");
  const [employeeGroup2Id, setEmployeeGroup2Id] = useState("");
  const [employeeTypeId, setEmployeeTypeId] = useState("");
  const [vesselId, setVesselId] = useState("");
  const [destinationId, setDestinationId] = useState("");

  const [plantilyaId, setPlantilyaId] = useState("");
  const [costCenterId, setCostCenterId] = useState("");
  const [clientId, setClientId] = useState("");
  //Accounts
  const [sss, setsss] = useState("");
  const [tin, setTin] = useState("");
  const [philhealth, setPhilhealth] = useState("");
  const [pagibig, setPagibig] = useState("");

  // Passport & Seaman's Book
  const [passport, setPassport] = useState("");
  const [passportIssueDate, setPassportIssueDate] = useState("");
  const [passportExpiryDate, setPassportExpiryDate] = useState("");
  const [seamansBookNumber, setSeamansBookNumber] = useState("");
  const [seamansBookIssueDate, setSeamansBookIssueDate] = useState("");
  const [seamansBookExpiryDate, setSeamansBookExpiryDate] = useState("");

  // License Information
  const [licenseCode, setLicenseCode] = useState("");
  const [licenseDescription, setLicenseDescription] = useState("");
  const [licenseNumber, setLicenseNumber] = useState("");
  const [licenseQualified, setLicenseQualified] = useState(false);
  const [licenseExpirationDate, setLicenseExpirationDate] = useState("");

  // Bank Accounts
  const [employeeBankAccounts, setEmployeeBankAccounts] = useState([]);

  //Education
  const [employeeEducationAttainments, setEmployeeEducationAttainments] = useState([]);
  const [employeeTrainingSeminars, setEmployeeTrainingSeminars] = useState([]);
  //Dependents
  const [employeeDependents, setEmployeeDependents] = useState([]);
  //Emegency
  const [employeeEmergencyContacts, setEmployeeEmergencyContacts] = useState([]);
  //Family
  const [employeeFamilyData, setEmployeeFamilyData] = useState([]);
  //Restdays
  const [employeeRestDays, setEmployeeRestDays] = useState([]);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const fetchDataAccessTemplate = useCallback(async () => {
    const apiUrl = domain + "/api/AccessTemplate";

    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }, []);

  const apiUrl = domain + "/api/Employee";

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    let availableSlots = [];

    if (HR7_IS_CLOUD) {
      try {
        availableSlots = await fetchAvailableSlot();
      } catch (err) {
        console.warn("fetchAvailableSlot failed:", err);

        // treat as NO SLOTS available
        availableSlots = [];
      }
    }

    // check if theres no License Key available
    if (HR7_IS_CLOUD && availableSlots.length === 0 && !getUnliAccount()) {
      setLoading(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Subscription limit reach.");
      return;
    }

    const now = new Date();

    const toBase64 = (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

    let base64String = "";
    let photoToBeSave = "";

    if (selectedFile) {
      base64String = await toBase64(selectedFile);
      photoToBeSave = base64String.split(',')[1];
    }

    let base64StringSignature = "";
    let photoToBeSavebase64StringSignature = "";

    if (signature.length > 0) {
      base64StringSignature = await toBase64(signature[0]);
      photoToBeSavebase64StringSignature = base64StringSignature.split(',')[1];
    }

    // 2. Process the Training and Seminars array to handle File objects and FileNames
    const processedTrainings = await Promise.all(
      employeeTrainingSeminars.map(async (item) => {
        let base64Content = item.file;

        // If 'file' is a raw File object (from the new component), convert it
        if (item.file instanceof File) {
          const fullBase64 = await toBase64(item.file);
          base64Content = fullBase64.split(',')[1]; // Get only the data part
        }

        return {
          title: item.title,
          dateFrom: item.dateFrom,
          dateTo: item.dateTo,
          file: base64Content,   // The base64 string
          fileName: item.fileName, // Explicitly include the filename string
          // fileType: item.fileType // Explicitly include the filename string
        };
      })
    );

    const data = {
      employeeId: employeeId.trim(),
      lastName: lastName,
      firstName: firstName,
      middleName: middleName,
      extensionName: extensionName,
      fullName: lastName + ", " + firstName,
      nickName: nickName,
      age: age ? age : 0,
      dateOfBirth: dateOfBirth ? dateOfBirth : null,
      placeOfBirth: placeOfBirth,
      civilStatus: civilStatus,
      bloodType: bloodType,
      height: height,
      weight: weight,
      citizenship: citizenship,
      religion: religion,
      gender: gender,
      mobileNumber: mobileNumber,
      emailAddress: emailAddress,
      blkLot: blkLot,
      street: street,
      barangay: barangay,
      city: city,
      municipality: municipality,
      postalCode: postalCode,
      yearsOfStay: yearsOfStay ? yearsOfStay : 0,
      photo: selectedFile ? photoToBeSave : null,
      deviceNumber: deviceNumber,
      signature: signature ? photoToBeSavebase64StringSignature : null,
      license: license,
      employeeInformation: {
        // employeePersonalInformationId: employeeId,
        effectiveFrom: effectiveFrom ? effectiveFrom : null,
        contractFrom: contractFrom ? contractFrom : null,
        contractTo: contractTo ? contractTo : null,
        locationId: locationId ? locationId : null,
        dateEmployed: dateEmployed ? dateEmployed : null,
        dateRegular: dateRegular ? dateRegular : null,
        dateProbationary: dateProbationary ? dateProbationary : null,
        dateProjectBase: dateProjectBase ? dateProjectBase : null,
        dateContractual: dateContractual ? dateContractual : null,
        employmentId: employmentId ? employmentId : null,
        departmentId: departmentId ? departmentId : null,
        sectionId: sectionId ? sectionId : null,
        classificationId: classificationId ? classificationId : null,
        payTypeId: payTypeId ? payTypeId : null,
        shiftScheduleId: shiftScheduleId ? shiftScheduleId : 1,
        positionId: positionId ? positionId : null,
        companyId: companyId ? companyId : null,
        salaryType: salaryType,
        maintenanceSalaryCombinationV2Id: maintenanceSalaryCombinationV2Id,
        jobTitleId: jobTitleId ? jobTitleId : null,
        employeeGroup1Id: employeeGroup1Id ? employeeGroup1Id : null,
        employeeGroup2Id: employeeGroup2Id ? employeeGroup2Id : null,
        plantilyaId: plantilyaId ? plantilyaId : null,
        costCenterId: costCenterId ? costCenterId : null,
        clientId: clientId ? clientId : null,
        employeeTypeId: employeeTypeId ? employeeTypeId : null,
        vesselId: vesselId ? vesselId : null,
        destinationId: destinationId ? destinationId : null,
        createdDate: now,
        createdBy: 0,
      },
      employeeReportTo: {
        // employeePersonalInformationId: employeeId,
        reportToId: null
      },
      employeeAccountInformation: {
        // employeePersonalInformationId: employeeId,
        sss: sss,
        tin: tin,
        passport: passport,
        philhealth: philhealth,
        pagibig: pagibig,
      },
      employeePassportDetail: {
        passportNumber: passport,
        passportIssueDate: passportIssueDate ? passportIssueDate : null,
        passportExpiryDate: passportExpiryDate ? passportExpiryDate : null,
      },
      employeeSeamanBookDetail: {
        seamanBookNumber: seamansBookNumber,
        bookIssueDate: seamansBookIssueDate ? seamansBookIssueDate : null,
        bookExpiryDate: seamansBookExpiryDate ? seamansBookExpiryDate : null,
      },
      employeeLicenseInformation: {
        licenseCode: licenseCode,
        licenseNumber: licenseNumber,
        description: licenseDescription,
        expirationDate: licenseExpirationDate ? licenseExpirationDate : null,
        isQualified: licenseQualified,
      },
      employeeBankAccounts: employeeBankAccounts,
      employeeEducationAttainments: employeeEducationAttainments,
      employeeTrainingSeminars: processedTrainings,
      employeeDependents: employeeDependents,
      employeeFamilyData: employeeFamilyData,
      employeeEmergencyContacts: employeeEmergencyContacts,
      employeeLeave: {
        // employeePersonalInformationId: employeeId,
        totalVacation: vacationLeave ? vacationLeave : 0,
        totalSick: sickLeave ? sickLeave : 0,
        totalServiceIncentive: serviceIncentiveLeave ? serviceIncentiveLeave : 0,
        totalSoloParent: soloParentLeave ? soloParentLeave : 0,
        sickRemaining: sickRemaining ? sickRemaining : 0,
        vacationRemaining: vacationRemaining ? vacationRemaining : 0,
        serviceIncentiveRemaining: serviceIncentiveRemaining ? serviceIncentiveRemaining : 0,
        soloParentRemaining: soloParentRemaining ? soloParentRemaining : 0
      },
      employeeStatuses: {
        // employeePersonalInformationId: employeeId,
        status: employeeStatus ? employeeStatus : "Active",
      },
      employeeRestDays: employeeRestDays
    };

    // console.log('Final bulkData:', JSON.stringify(data, null, 2));
    console.log('Final bulkData:', { data });

    try {

      // insert on subscription API
      // const availableSlots = HR7_IS_CLOUD ? await fetchAvailableSlot() : null; // cloud

      if (HR7_IS_CLOUD && availableSlots.length === 0 && !getUnliAccount()) { // for cloud only
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("Creation failed, please contact your service provider for more details.");
        console.log('No available slot.');
        return;
      }

      if (HR7_IS_CLOUD && license && !getUnliAccount()) {
        const isLicenseTaken = await checkLicenseIfTaken(license, employeeId.trim());

        if (isLicenseTaken === true) { // insert if the license is not taken
          setShowRequestMessage(true);
          setIsSuccess(false);
          setRequestMessage("License has been used.");
          return;
        }
        await insertUserSubscription(license, employeeId.trim());
      }

      const response = await axios.post(apiUrl, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      await createAccount(response.data);
      await SetAuditTrail({
        setupArea: "Add Employee",
        actionTaken: "insert",
        field: "Add Employee",
        newValue: `${data.fullName}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      // Reload table data and reset form fields
      setEmployeeId("");
      setLastName("");
      setFirstName("");
      setMiddleName("");
      setExtensionName("");
      setNickName("");
      setAge("");
      setDateOfBirth("");
      setPlaceOfBirth("");
      setCivilStatus("");
      setBloodType("");
      setHeight("");
      setWeight("");
      setCitizenship("");
      setReligion("");
      setGender("");
      setMobileNumber("");
      setEmailAddress("");
      setDeviceNumber("");
      setCompanyTypeId("");
      setSignature([]);
      setSelectedFile("");
      setLicense("");
      //Address
      setBlkLot("");
      setStreet("");
      setBarangay("");
      setCity("");
      setMunicipality("");
      setPostalCode("");
      setYearsOfStay("");
      //Information
      setEffectiveFrom("");
      setContractFrom("");
      setContractTo("");
      setLocationId("");
      setDateEmployed("");
      setDateRegular("");
      setDateProbationary("");
      setDateProjectBase("");
      setDateContractual("");
      setEmploymentId("");
      setDepartmentId("");
      setSectionId("");
      setClassificationId("");
      setPayTypeId("");
      setShiftScheduleId("");
      setPositionId("");
      setVacationLeave("");
      setSickLeave("");
      setServiceIncentiveLeave("");
      setSoloParentLeave("");
      setVacationRemaining("");
      setSickRemaining("");
      setServiceIncentiveRemaining("");
      setSoloParentRemaining("");
      setEmployeeStatus("");
      setSalaryType("");
      setmaintenanceSalaryCombinationV2Id("");
      setJobTitleId("");
      setEmployeeGroup1Id("");
      setEmployeeGroup2Id("");
      setPlantilyaId("");
      setCostCenterId("");
      setClientId("");
      setEmployeeTypeId("");
      setVesselId("");
      setDestinationId("");
      //Accounts
      setsss("");
      setTin("");
      setPassport("");
      setPassportIssueDate("");
      setPassportExpiryDate("");
      setSeamansBookNumber("");
      setSeamansBookIssueDate("");
      setSeamansBookExpiryDate("");
      setPhilhealth("");
      setPagibig("");
      setLicenseCode("");
      setLicenseDescription("");
      setLicenseNumber("");
      setLicenseQualified(false);
      setLicenseExpirationDate("");
      setEmployeeBankAccounts([]);
      //Education
      setEmployeeEducationAttainments([]);
      //Dependents
      setEmployeeDependents([]);
      //Emegency
      setEmployeeEmergencyContacts([]);
      //Family
      setEmployeeFamilyData([]);

      console.log('Data added successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      setLoading(false);
      console.error('There was a problem adding data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  };

  const fetchDataAccounts = useCallback(async () => {
    const apiUrl = domain + "/api/Authentication/all-usernames";

    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return []
    }
  }, []);
  const fetchDataEmployeeByEmployeeId = useCallback(async (employeeId) => {
    const apiUrl = domain + "/api/Employee";

    try {
      setLoading(true);
      const response = await axios.get(apiUrl + `/employeeId/${employeeId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);

  const createAccount = async (employee) => {
    const accessTemplate = await fetchDataAccessTemplate();
    const employeeInfo = await fetchDataEmployeeByEmployeeId(employee.employeeId);
    const accounts = await fetchDataAccounts();

    const foundTemplate = accessTemplate.find(data =>
      data.description.toLowerCase() === ("Employee").toLowerCase()
    );
    /* const foundEmployee = employeeInfo.find(data => 
      data.employeeId.toLowerCase().trim() === employee.employeeId.toLowerCase().trim()
    ); */

    function generateUniqueUsernames(employee, existingUsernames) {
      const firstNameInitial = employee.firstName.charAt(0).toLowerCase();
      const lastNameLower = employee.lastName.replace(/\s+/g, '').toLowerCase(); // Remove spaces from last name
      let baseUsername = firstNameInitial + lastNameLower;

      let uniqueUsername = baseUsername;
      let counter = 1;

      while (existingUsernames.includes(uniqueUsername)) {
        uniqueUsername = `${baseUsername}${counter}`;
        counter += 1;
      }

      existingUsernames.push(uniqueUsername); // Add the new username to the list to avoid duplicates
      return uniqueUsername;
    }

    console.log(employee)

    const apiUrl = domain + "/api/Authentication";

    const existingUsernames = [];

    accounts.forEach(employee => {
      existingUsernames.push(employee.username);
    });

    const username = generateUniqueUsernames(employee, existingUsernames);
    existingUsernames.push(username);

    const data = {
      username: username,
      password: "password",
      employeePersonalInformationId: employeeInfo.id,
      accessTemplateId: foundTemplate.id
    };

    try {
      axios.post(apiUrl + `/register`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

    } catch (error) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    }
  }

  useEffect(() => {
    if (selectedTab > 0) {
      setIsFirstPage(false);
    } else {
      setIsFirstPage(true);
    }

    if (selectedTab === 7) {
      setIsLastPage(true);
    } else {
      setIsLastPage(false);
    }
  }, [selectedTab]); // This useEffect will run whenever selectedTab changes

  const setButtonId = (name) => {
    if (name === "previous-button") {
      if (isFirstPage) {
        return "previous-button"
      } else {
        return "active-previous-button"
      }
    } else if (name === "next-button") {
      if (isLastPage) {
        return "next-button"
      } else {
        return "active-next-button"
      }
    }
  }

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="EmployeesTabInfo shadow-xl">
            <div className="employeesTab-header">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Personnel >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Add Employee"}</span>
              </div>
              <div className="employeesTab-title">
                <h3 style={{ textAlign: "center", fontSize: "30px" }}>Create Employee Profile</h3>
                <label style={{
                  color: "#808080b5",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                > This information will let us know more about you.
                </label>
              </div>

            </div>
            <div className="employeesTab-body">
              <div className='employeesTab-tab'>
                <div style={{ border: "1px solid #00000026", borderRadius: "5px" }}>
                  <Tabs id="employees-tabs-element" selectedIndex={selectedTab} onSelect={index => setSelectedTab(index)}>
                    <TabList>
                      <Tab><b>PERSONAL</b></Tab>
                      <Tab><b>ADDRESS</b></Tab>
                      <Tab><b>INFORMATION</b></Tab>
                      <Tab><b>ACCOUNTS</b></Tab>
                      <Tab><b>EDUCATIONS</b></Tab>
                      <Tab><b>DEPENDENTS</b></Tab>
                      <Tab><b>EMERGENCY</b></Tab>
                      <Tab><b>FAMILY</b></Tab>
                    </TabList>
                    <div className="employeesTab-tabPanel" style={{ height: "auto" }}>
                      <TabPanel>
                        <PersonalTab employeeId={employeeId}
                          selectedFile={selectedFile}
                          setSelectedFile={setSelectedFile}
                          lastName={lastName}
                          firstName={firstName}
                          middleName={middleName}
                          extensionName={extensionName}
                          nickName={nickName}
                          age={age}
                          dateOfBirth={dateOfBirth}
                          placeOfBirth={placeOfBirth}
                          civilStatus={civilStatus}
                          bloodType={bloodType}
                          height={height}
                          weight={weight}
                          citizenship={citizenship}
                          religion={religion}
                          gender={gender}
                          mobileNumber={mobileNumber}
                          emailAddress={emailAddress}
                          deviceNumber={deviceNumber}
                          companyId={companyId}
                          license={license}
                          setEmployeeId={setEmployeeId}
                          setLastName={setLastName}
                          setFirstName={setFirstName}
                          setMiddleName={setMiddleName}
                          setExtensionName={setExtensionName}
                          setNickName={setNickName}
                          setAge={setAge}
                          setDateOfBirth={setDateOfBirth}
                          setPlaceOfBirth={setPlaceOfBirth}
                          setCivilStatus={setCivilStatus}
                          setBloodType={setBloodType}
                          setHeight={setHeight}
                          setWeight={setWeight}
                          setCitizenship={setCitizenship}
                          setReligion={setReligion}
                          setLicense={setLicense}
                          setGender={setGender}
                          setMobileNumber={setMobileNumber}
                          setEmailAddress={setEmailAddress}
                          setDeviceNumber={setDeviceNumber}
                          setCompanyId={setCompanyTypeId}

                          signature={signature}
                          setSignature={setSignature}

                          isEditMode={true}
                          isAddMode={true}
                        />
                      </TabPanel>

                      <TabPanel>
                        <AddressTab
                          blkLot={blkLot}
                          street={street}
                          barangay={barangay}
                          city={city}
                          municipality={municipality}
                          postalCode={postalCode}
                          yearsOfStay={yearsOfStay}
                          setBlkLot={setBlkLot}
                          setStreet={setStreet}
                          setBarangay={setBarangay}
                          setCity={setCity}
                          setMunicipality={setMunicipality}
                          setPostalCode={setPostalCode}
                          setYearsOfStay={setYearsOfStay}

                          isEditMode={true}
                        />
                      </TabPanel>

                      <TabPanel>
                        <InformationTab
                          effectiveFrom={effectiveFrom}
                          contractFrom={contractFrom}
                          contractTo={contractTo}
                          locationId={locationId}
                          dateEmployed={dateEmployed}
                          dateRegular={dateRegular}
                          dateProbationary={dateProbationary}
                          dateProjectBase={dateProjectBase}
                          dateContractual={dateContractual}
                          employmentId={employmentId}
                          departmentId={departmentId}
                          sectionId={sectionId}
                          classificationId={classificationId}
                          payTypeId={payTypeId}
                          shiftScheduleId={shiftScheduleId}
                          positionId={positionId}
                          salaryType={salaryType}
                          maintenanceSalaryCombinationV2Id={maintenanceSalaryCombinationV2Id}
                          employeeStatus={employeeStatus}
                          setEffectiveFrom={setEffectiveFrom}
                          setContractFrom={setContractFrom}
                          setContractTo={setContractTo}
                          setLocationId={setLocationId}
                          setDateEmployed={setDateEmployed}
                          setDateRegular={setDateRegular}
                          setDateProbationary={setDateProbationary}
                          setDateProjectBase={setDateProjectBase}
                          setDateContractual={setDateContractual}
                          setEmploymentId={setEmploymentId}
                          setDepartmentId={setDepartmentId}
                          setSectionId={setSectionId}
                          setClassificationId={setClassificationId}
                          setPayTypeId={setPayTypeId}
                          setShiftScheduleId={setShiftScheduleId}
                          setPositionId={setPositionId}
                          setSalaryType={setSalaryType}
                          setmaintenanceSalaryCombinationV2Id={setmaintenanceSalaryCombinationV2Id}
                          sickLeave={sickLeave}
                          setSickLeave={setSickLeave}
                          vacationLeave={vacationLeave}
                          setVacationLeave={setVacationLeave}
                          serviceIncentiveLeave={serviceIncentiveLeave}
                          setServiceIncentiveLeave={setServiceIncentiveLeave}
                          soloParentLeave={soloParentLeave}
                          setSoloParentLeave={setSoloParentLeave}
                          setEmployeeStatus={setEmployeeStatus}

                          sickRemaining={sickRemaining}
                          setSickRemaining={setSickRemaining}
                          vacationRemaining={vacationRemaining}
                          setVacationRemaining={setVacationRemaining}
                          serviceIncentiveRemaining={serviceIncentiveRemaining}
                          setServiceIncentiveRemaining={setServiceIncentiveRemaining}
                          soloParentRemaining={soloParentRemaining}
                          setSoloParentRemaining={setSoloParentRemaining}

                          jobTitleId={jobTitleId} setJobTitleId={setJobTitleId}
                          employeeGroup1Id={employeeGroup1Id} setEmployeeGroup1Id={setEmployeeGroup1Id}
                          employeeGroup2Id={employeeGroup2Id} setEmployeeGroup2Id={setEmployeeGroup2Id}

                          plantilyaId={plantilyaId}
                          setPlantilyaId={setPlantilyaId}
                          costCenterId={costCenterId}
                          setCostCenterId={setCostCenterId}
                          clientId={clientId}
                          setClientId={setClientId}

                          employeeRestDays={employeeRestDays} setEmployeeRestDays={setEmployeeRestDays}
                          employeeTypeId={employeeTypeId} setEmployeeTypeId={setEmployeeTypeId}
                          vesselId={vesselId} setVesselId={setVesselId}
                          destinationId={destinationId} setDestinationId={setDestinationId}

                          isEditMode={true}
                          isAddMode={true}
                        />
                      </TabPanel>

                      <TabPanel>
                        <AccountsTab
                          // Government
                          sss={sss}
                          tin={tin}
                          philhealth={philhealth}
                          pagibig={pagibig}
                          setsss={setsss}
                          setTin={setTin}
                          setPhilhealth={setPhilhealth}
                          setPagibig={setPagibig}

                          // Passport & Seaman
                          passport={passport}
                          setPassport={setPassport}
                          passportIssueDate={passportIssueDate}
                          setPassportIssueDate={setPassportIssueDate}
                          passportExpiryDate={passportExpiryDate}
                          setPassportExpiryDate={setPassportExpiryDate}
                          seamansBookNumber={seamansBookNumber}
                          setSeamansBookNumber={setSeamansBookNumber}
                          seamansBookIssueDate={seamansBookIssueDate}
                          setSeamansBookIssueDate={setSeamansBookIssueDate}
                          seamansBookExpiryDate={seamansBookExpiryDate}
                          setSeamansBookExpiryDate={setSeamansBookExpiryDate}

                          // License Info
                          licenseCode={licenseCode}
                          setLicenseCode={setLicenseCode}
                          licenseDescription={licenseDescription}
                          setLicenseDescription={setLicenseDescription}
                          licenseNumber={licenseNumber}
                          setLicenseNumber={setLicenseNumber}
                          licenseQualified={licenseQualified}
                          setLicenseQualified={setLicenseQualified}
                          licenseExpirationDate={licenseExpirationDate}
                          setLicenseExpirationDate={setLicenseExpirationDate}

                          // Bank Accounts
                          employeeBankAccounts={employeeBankAccounts}
                          setEmployeeBankAccounts={setEmployeeBankAccounts}

                          isEditMode={true}
                        />
                      </TabPanel>

                      <TabPanel>
                        <Tabs id="educations-tabs-element" selectedIndex={selectedEducationTab} onSelect={index => setSelectedEducationTab(index)}>
                          <TabList>
                            <Tab><b>EDUCATIONS</b></Tab>
                            <Tab><b>TRAININGS & SEMINARS</b></Tab>
                          </TabList>
                          <TabPanel>
                            <EducationsTab
                              employeePersonalInformationId={employeeId}
                              employeeEducationAttainments={employeeEducationAttainments}
                              setEmployeeEducationAttainments={setEmployeeEducationAttainments}

                              isEditMode={true}
                            />
                          </TabPanel>
                          <TabPanel>
                            <TrainingsAndSeminarsTab
                              employeePersonalInformationId={employeeId} // handled on the backend, no bearing
                              employeeTrainingSeminars={employeeTrainingSeminars}
                              setEmployeeTrainingSeminars={setEmployeeTrainingSeminars}

                              isEditMode={true}
                            />
                          </TabPanel>
                        </Tabs>
                      </TabPanel>

                      <TabPanel>
                        <DependentsTab employeeId={employeeId}
                          employeeDependents={employeeDependents}
                          setEmployeeDependents={setEmployeeDependents}

                          isEditMode={true}
                        />
                      </TabPanel>

                      <TabPanel>
                        <EmergencyTab employeeId={employeeId}
                          employeeEmergencyContacts={employeeEmergencyContacts}
                          setEmployeeEmergencyContacts={setEmployeeEmergencyContacts}

                          isEditMode={true}
                        />
                      </TabPanel>

                      <TabPanel>
                        <FamilyTab employeeId={employeeId}
                          employeeFamilyData={employeeFamilyData}
                          setEmployeeFamilyData={setEmployeeFamilyData}

                          isEditMode={true}
                        />
                      </TabPanel>
                    </div>
                  </Tabs>

                </div>
                <div className="tab-footer">
                  <div className="buttons row" style={{ justifyContent: "space-between" }}>
                    <button id={setButtonId("previous-button")}
                      className="previous row"
                      onClick={() => setSelectedTab(Previous(selectedTab))}><NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
                    </button>
                    <button id={setButtonId("next-button")}
                      className="next row"
                      onClick={() => setSelectedTab(Next(selectedTab))}> NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                  </div>
                </div>
                <div className="lowerpart">
                  <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
                    <button className="submit"
                      onClick={(event) => handleSubmit(event)}> SUBMIT
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GenerateMessage form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "5000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </div>
  )
}

function Previous(currentSelected) {
  if (currentSelected !== 0) { return (currentSelected - 1); } else { return currentSelected }
}
function Next(currentSelected) {
  if (currentSelected !== 7) { return (currentSelected + 1); } else { return currentSelected }
}
export default AddEmployee